// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__i3RkI","header":"ReportDetails_header__38H44","title":"ReportDetails_title__2a8Li","left":"ReportDetails_left__1-tav"};